import { useEffect } from 'react';

import { useAppState } from '../../../AppStateProvider';
import type { Page } from '../../../domain/page';
import { pagesTrackingConfig } from '../trackingConfig';
import TrackingPageViewService from '../TrackingPageViewService';

export const usePredefinedPageViewTracking = ({ page, isSwUser }: { page: Page; isSwUser: boolean }) => {
  const { isOpen, url } = useAppState();

  useEffect(() => {
    if (!isOpen || !url) {
      return;
    }
    const config = pagesTrackingConfig.find((config) => config.trackingId === page);
    TrackingPageViewService.trackPageView({ isSwUser, config, url, page });
  }, [isOpen]);
};
